import { yieldToMain } from '@/root/utils/yield-to-main'
import classNames from 'classnames'
import type { ReactNode } from 'react'

export function Chip({
  children,
  width = 1,
  isActive = false,
  onClick = () => null,
  maxContent = false,
}: {
  children: ReactNode
  width?: number
  isActive?: boolean
  onClick: (e) => void
  maxContent?: boolean
}) {
  const activeChipStyle = isActive
    ? 'bg-ind-blue rounded-full text-white'
    : 'text-grey-dark'

  return (
    <li
      style={maxContent ? {} : { width: `${100 / width}%` }}
      className={classNames(
        `text-center font-medium ${activeChipStyle} cursor-pointer`,
        { 'px-4': maxContent },
      )}
      onClick={onClick}
    >
      {children}
    </li>
  )
}

export function ChipContainer({
  children,
  noBottomMargin = false,
  maxContent = false,
}: {
  children: ReactNode
  noBottomMargin?: boolean
  maxContent?: boolean
}) {
  return (
    <ul
      className={`no-scrollbar border-grey-tertiary flex overflow-auto rounded-full border ${
        noBottomMargin ? 'mb-0' : 'my-2'
      } ${maxContent ? 'w-max' : ''}`}
    >
      {children}
    </ul>
  )
}

interface HorizontalNavigationProps {
  data: Array<{ selected: boolean; title: string; subTitle?: string }>
  onSelect: (title: string, e) => void
  labelClassName?: string
  subTitleClassName?: string
  noBottomMargin?: boolean
  titleClassName?: string
  maxContent?: boolean
}
export default function HorizontalNavigation(props: HorizontalNavigationProps) {
  const {
    data,
    onSelect,
    labelClassName,
    subTitleClassName,
    noBottomMargin = false,
    titleClassName = 'text-base font-medium',
    maxContent = false,
  } = props

  return (
    <ChipContainer noBottomMargin={noBottomMargin} maxContent={maxContent}>
      {data.map(chip => (
        <Chip
          width={data.length}
          isActive={chip.selected}
          onClick={async e => {
            await yieldToMain()
            onSelect(chip.title, e)
          }}
          key={chip.title}
          maxContent={maxContent}
        >
          <div
            className={
              labelClassName ??
              'flex h-full flex-col items-center justify-center px-3 py-2 md:flex-row'
            }
          >
            <p className={titleClassName}>{chip.title}</p>
            {chip.subTitle && (
              <span className={subTitleClassName}>{chip.subTitle}</span>
            )}
          </div>
        </Chip>
      ))}
    </ChipContainer>
  )
}
